<div class="content-wrapper">
	<div class="content-head qo-padding10" *ngIf="!punchUser">
		<h2>{{'BULLETINBOARD.ALL' | translate}}</h2>
		<button
			class="qo-button-small qo-white"
			(click)="goToBulletinBoard()"
			*ngIf="showAllPosts">{{'DASHBOARD.SEE_ALL_POSTS' | translate}}</button>
	</div>
	<div *ngIf="bulletinBoardPost">
		<div class="board-post-holder" [ngStyle]="{'padding': contentPadding + 'px'}">
			<div class="post-head">
				<div class="profile-name">
					<qo-profile-image
						[imageUrl]="bulletinBoardPost.user.profile_picture?.download_url"
						[letter]="bulletinBoardPost.user.getInitials()"
						[size]="40"
					></qo-profile-image>
					<div class="profile-info qo-margin-left15">
						<div class="full-name bold">
							{{bulletinBoardPost.user.getFullName()}}
						</div>
						<div class="post-date bold">
							{{bulletinBoardPost.created_at.localDate | smLocalDate:'mediumDate'}}
						</div>
					</div>
				</div>
				<div class="seen-by bold" (click)="getInfoSeenBy(bulletinBoardPost)">
					{{ 'MESSAGE_BOARD.SEEN_BY' | translate }}
					<ng-container
						*ngIf="bulletinBoardPost.seen_by_count == 0"> {{ 'MESSAGE_BOARD.NOONE' | translate }}</ng-container>
					<ng-container
						*ngIf="bulletinBoardPost.seen_by_count > 0"> {{bulletinBoardPost.seen_by_count}}</ng-container>
				</div>
			</div>
			<div
				class="post-content"
				[innerHTML]="bulletinBoardPost.content | linkify"
			></div>
			<div class="post-files" style="max-width: 200px;">
				<app-file-entry-edit
					[fileEntries]="bulletinBoardPost.file_entries"
					[edit]="false"
				>
				</app-file-entry-edit>
			</div>
			<div class="post-social">
				<div class="social-like" *ngIf="canLike">
					<qo-icon
						[icon]="bulletinBoardPost.liked ? EQORebrandIcon.heart_dark : EQORebrandIcon.heart_dark_filled"
						[invertedScheme]="true"
						[scheme]="EQORebrandColor.SECONDARY"
						[color]="EQORebrandColor.SECONDARY"
						[size]="'sm'"
						(click)="likeOrDislikePost(bulletinBoardPost)"
					></qo-icon>
				</div>
				<div class="social-info">
					<div class="social-likes" (click)="getInfoLikedBy(bulletinBoardPost)">
						<div>
							<qo-overlapping-oval-icons
								[overlappingIcons]="bulletinBoardPost.overlappingLikeIcons"
								[stackMargin]="5"
								[baseIcon]="bulletinBoardPost.message_board_post_likes_count > 4 ? ICON.PLUS_GREY3 : ICON.NONE"
							></qo-overlapping-oval-icons>
						</div>
						<div class="social-number-of-likes">
							{{ bulletinBoardPost.message_board_post_likes_count | i18nPlural: {
							'=0': 'MESSAGE_BOARD.LIKES.NONE',
							'=1': 'MESSAGE_BOARD.LIKES.SINGLE',
							'other': 'MESSAGE_BOARD.LIKES.PLUR'
						} | translate:{x: bulletinBoardPost.message_board_post_likes_count} }}
						</div>
					</div>

					<div class="social-comments" (click)="goToBulletinBoard()">
						<qo-icon
							[icon]="EQORebrandIcon.chat_dark"
							[invertedScheme]="true"
							[scheme]="EQORebrandColor.SECONDARY"
							[color]="EQORebrandColor.SECONDARY"
							[size]="'sm'"
						></qo-icon>
						<div class="social-number-of-comments">
							{{ bulletinBoardPost.message_board_post_comments_count | i18nPlural: {
							'=0': 'MESSAGE_BOARD.COMMENTS.NONE',
							'=1': 'MESSAGE_BOARD.COMMENTS.SINGLE',
							'other': 'MESSAGE_BOARD.COMMENTS.PLUR'
						} | translate:{x: bulletinBoardPost.message_board_post_comments_count} }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="line-breaker" *ngIf="bulletinBoardPost.comments.length > 0"></div>
		<div class="post-comments" *ngIf="showComments">
			<div class="comment-holder" [class.padding10]="!punchUser"
					 *ngFor="let comment of bulletinBoardPost.comments; let i = index; trackBy:trackById">
				<div class="comment-holder-comment-data">
					<div class="comment-holder-profile">
						<qo-profile-image
							[letter]="comment.user.getInitials()"
							[imageUrl]="comment.user.profile_picture?.download_url"
							[size]="40"
							[fontSize]="20"
						></qo-profile-image>
						<div class="comment-holder-profile-name-and-text">
							<div class="name-time-holder">
								<div class="name">{{comment.user.getFullName()}}</div>
								<div class="comment-holder-right-side">
									<div class="comment-holder-info-date bold">
										{{comment.created_at.format('short')}}
									</div>
								</div>
							</div>
							<div class="comment-text"
									 [innerHTML]="comment.comment | linkify"
							></div>
						</div>
					</div>
				</div>
				<div class="line-breaker" *ngIf="i < bulletinBoardPost.comments.length -1"></div>
			</div>

			<div
				class="load-more-comments"
				[class.padding10]="!punchUser"
				*ngIf="bulletinBoardPost.message_board_post_comments_count > bulletinBoardPost.comments.length && bulletinBoardPost.message_board_post_comments_count > 1">
				<button class="qo-button-small qo-secondary"
								(click)="getMoreComments(bulletinBoardPost)">{{ 'MESSAGE_BOARD.LOAD_MORE_COMMENTS' | translate}}</button>
			</div>
		</div>
	</div>
</div>
